import {
  GET_BOARD_REPORTS_REQUEST,
  GET_BOARD_REPORTS_SUCCESS,
  GET_BOARD_REPORTS_FAIL,
  CLEAR_BOARD_REPORTS,
} from "./boardReportsTypes";

const initialState = {
  chartData: null,
  TasksData: null,
  loading: false,
  error: null,
};

export const boardReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOARD_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_BOARD_REPORTS_SUCCESS:
      return {
        ...state,
        chartData: action.payload.chartData,
        TasksData: action.payload.TasksData,
        loading: false,
        error: null,
      };

    case GET_BOARD_REPORTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_BOARD_REPORTS:
      return initialState;

    default:
      return state;
  }
};
